<div class="company-location-selector">

  <!-- Stepper header -->
  <div class="dialog-topbar">
    <div class="steps">
      <div class="step" data-testid="selector-step-company" [class.active]="step === 'company'" [class.completed]="step !== 'company'">
        <span class="step-icon"></span>
        <span class="step-label">{{ 'companies_selection_dialog.step_billing_company' | translate }}</span>
        <div class="seperator">
          <img src="assets/icones/chevron_right.svg" alt="">
        </div>
      </div>
      <div class="step" data-testid="selector-step-location" [class.active]="step === 'location' || step === 'create'">
        <span class="step-icon"></span>
        <span class="step-label">{{ 'companies_selection_dialog.step_shipping_location' | translate }}</span>
      </div>
    </div>
    <ui-button type="transparent" icon="close" iconSize="large" testId="selector-close" (click)="cancel()"></ui-button>
  </div>

  <!-- STEP 1: company selection -->
  <ng-container *ngIf="step === 'company'">
    <div class="search-container">
      <ui-form-field [ngModel]="companySearchTerm" (ngModelChange)="onCompanySearch($event)"
        [placeholder]="'companies_selection_dialog.search_companies_placeholder' | translate" type="text"
        suffixIcon="search">
      </ui-form-field>
    </div>

    <div class="company-selection">
      <div class="loading-more" *ngIf="isLoading">
        <ui-svg-icon svgIcon="eclipse"></ui-svg-icon>
      </div>
      <ng-container *ngIf="!isLoading">
        <div class="companies-list" *ngIf="companies.length > 0" (scroll)="onScroll($event)" #scrollContainer>
          <mat-radio-group aria-label="Select an option">
            <ng-container *ngFor="let item of companies; let i = index">
              <!-- WB-7520: the whole card is the click target, not just the radio. -->
              <div class="company-item" [attr.data-testid]="'company-item-' + item.id" (click)="selectCompany(item)">
                <mat-radio-button [value]="item" [checked]="selectedCompany?.id === item.id"
                  (change)="selectCompany(item)">
                  <span class="company-name">{{ item.name }}</span>
                  <span class="company-id company-address">{{getMainLocationAddress(item)}}</span>
                  <span class="company-id">{{ item.company_id }}</span>
                </mat-radio-button>
                <span class="location-count">
                  {{ 'companies_selection_dialog.locations_count' | translate:{ count: (item.locations?.length || 0) } }}
                </span>
              </div>
            </ng-container>
          </mat-radio-group>
          <div class="load-more">
            <div class="loading-more" *ngIf="isLoadingMore">
              <ui-svg-icon svgIcon="eclipse"></ui-svg-icon>
            </div>

            <ui-button *ngIf="isLoadMoreError" type="transparent"
              [label]="'companies_selection_dialog.load_more' | translate" (click)="loadMore()" [fullWidth]="true">
            </ui-button>

            <ui-button *ngIf="!isLoadingMore && !isLoadMoreError && canLoadMore" type="transparent"
              [label]="'companies_selection_dialog.load_more' | translate" (click)="loadMore()" [fullWidth]="true">
            </ui-button>
          </div>
        </div>
        <div class="no-data" *ngIf="companies.length === 0">
          <ui-svg-icon svgIcon="empty-inbox"></ui-svg-icon>
          <p>{{ 'companies_selection_dialog.no_data' | translate }}</p>
        </div>
      </ng-container>
    </div>

    <div class="dialog-footer">
      <ui-button type="secondary" [label]="'companies_selection_dialog.cancel' | translate"
        testId="selector-cancel" (click)="cancel()"></ui-button>
      <ui-button type="primary" [label]="'companies_selection_dialog.proceed' | translate"
        icon="arrow-right" iconPosition="end" testId="selector-primary" [disabled]="primaryDisabled" (click)="onPrimary()"></ui-button>
    </div>
  </ng-container>

  <!-- STEP 2: location selection -->
  <ng-container *ngIf="step === 'location'">
    <div class="location-selection">
      <div class="loading-more" *ngIf="isLoading">
        <ui-svg-icon svgIcon="eclipse"></ui-svg-icon>
      </div>

      <ng-container *ngIf="!isLoading">
        <div class="location-search-row">
          <ui-form-field [ngModel]="locationSearchTerm" (ngModelChange)="onLocationSearch($event)"
            [placeholder]="'companies_selection_dialog.search_locations_placeholder' | translate"
            type="text" suffixIcon="search" [fullWidth]="true">
          </ui-form-field>
          <ui-button *ngIf="featureFlags.allowCreateShippingAddress" type="secondary" icon="plus" iconPosition="end"
            [label]="'companies_selection_dialog.create' | translate" testId="selector-create-location" (click)="goToCreate()"></ui-button>
        </div>

        <div class="loading-more" *ngIf="globalLocationLoading">
          <ui-svg-icon svgIcon="eclipse"></ui-svg-icon>
        </div>

        <div class="locations-list" *ngIf="!globalLocationLoading && displayedLocations.length > 0"
          (scroll)="onLocationScroll($event)">
          <mat-radio-group aria-label="Select an option" [(ngModel)]="selectedLocation">
            <ng-container *ngFor="let item of displayedLocations; let i = index">
              <!-- WB-7520: the whole card is the click target, not just the radio. -->
              <div class="location-item" [attr.data-testid]="'location-item-' + item.id" (click)="selectLocation(item)">
                <mat-radio-button [value]="item">
                  <span *ngIf="billingShippingDifferent && item.company_name" class="location-company-name">
                    {{ item.company_name }}
                  </span>
                  <div class="location-header">
                    <span class="location-name">{{ item.name }}</span>
                    <span class="location-tags">
                      <span
                        *ngIf="item.provenance?.source === 'volta'"
                        class="volta-location-icon"
                        [matTooltip]="'customers.contacts_tab.volta_location_tooltip' | translate"
                        matTooltipClass="product-status-tooltip volta-location-tooltip"
                        matTooltipPosition="above"
                      >
                        <img src="assets/icones/volta_smal_icon.svg" alt="Volta" width="14" height="14">
                      </span>
                      <span *ngIf="item.is_new" class="new-tag">
                        {{ 'companies_selection_dialog.new' | translate }}
                      </span>
                      <span *ngIf="item.is_main" class="main-tag">
                        {{ 'companies_selection_dialog.main' | translate }}
                      </span>
                    </span>
                  </div>
                </mat-radio-button>
                <span class="location-address">{{ item.shipping_address || item.apartment }}</span>
                <!-- WB-7520: ERP ID, mirroring the identifier shown on step 1's company rows.
                     Hidden when the location has no ERP counterpart (created in Volta). -->
                <span class="location-erp-id" *ngIf="item.erp_id">{{ item.erp_id }}</span>
              </div>
            </ng-container>
          </mat-radio-group>
          <div class="loading-more" *ngIf="globalLocationLoadingMore">
            <ui-svg-icon svgIcon="eclipse"></ui-svg-icon>
          </div>
        </div>
        <div class="no-data" *ngIf="!globalLocationLoading && displayedLocations.length === 0">
          <ui-svg-icon svgIcon="empty-inbox"></ui-svg-icon>
          <p>{{ 'companies_selection_dialog.no_data' | translate }}</p>
        </div>

        <div class="billing-shipping-toggle">
          <mat-slide-toggle [checked]="billingShippingDifferent"
            (change)="onBillingShippingToggle($event.checked)">
            {{ 'companies_selection_dialog.billing_shipping_different' | translate }}
          </mat-slide-toggle>
        </div>
      </ng-container>
    </div>

    <div class="dialog-footer">
      <ui-button type="secondary" icon="arrow-left" iconPosition="start"
        [label]="'companies_selection_dialog.back' | translate" testId="selector-back" (click)="back()"></ui-button>
      <ui-button type="primary" [label]="'companies_selection_dialog.confirm' | translate"
        icon="arrow-right" iconPosition="end" testId="selector-primary" [disabled]="primaryDisabled" (click)="onPrimary()"></ui-button>
    </div>
  </ng-container>

  <!-- STEP 3: create location -->
  <ng-container *ngIf="step === 'create'">
    <app-create-location-form #createForm
      [defaultCompany]="parentCompany"
      [prefill]="prefill"
      [orderId]="orderId"
      (create)="onCreateLocation($event)">
    </app-create-location-form>

    <div class="dialog-footer">
      <ui-button type="secondary" icon="arrow-left" iconPosition="start"
        [label]="'companies_selection_dialog.back' | translate" testId="selector-back" (click)="back()"></ui-button>
      <ui-button type="primary" [label]="'companies_selection_dialog.create' | translate" testId="selector-create-submit"
        icon="arrow-right" iconPosition="end" [disabled]="!createForm.valid" (click)="createForm.submit()"></ui-button>
    </div>
  </ng-container>

</div>
